var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFowler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.1,
    height: 68.101,
    viewBox: "0 0 68.1 68.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1448",
    "data-name": "Grupo 1448",
    transform: "translate(402.231 -8187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1445",
    "data-name": "Grupo 1445",
    transform: "translate(78.086 -162.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1603",
    "data-name": "Trazado 1603",
    d: "M204.078,13.337h-10.7a2.455,2.455,0,0,1,0-4.911h10.7a2.455,2.455,0,1,1,0,4.911",
    transform: "translate(-655 8378.643)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1604",
    "data-name": "Trazado 1604",
    d: "M207.043,20.978a2.452,2.452,0,0,1-2.308-1.621l-2.347-6.5-2.345,6.5a2.454,2.454,0,1,1-4.616-1.67L200.079,4.8a2.456,2.456,0,0,1,4.619,0l4.653,12.891a2.457,2.457,0,0,1-2.308,3.29",
    transform: "translate(-648.657 8371.001)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1605",
    "data-name": "Trazado 1605",
    d: "M212.228,13.337h-10.7a2.455,2.455,0,1,1,0-4.911h10.7a2.455,2.455,0,1,1,0,4.911",
    transform: "translate(-643.138 8378.643)",
    fill: "#02ceff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1444",
    "data-name": "Grupo 1444",
    transform: "translate(-1372.826 2860.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(970.595 5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFowler);
export default __webpack_public_path__ + "static/media/ic_fowler.dbc1a8cbcdd4e6e879d132f0ab4ef365.svg";
export { ForwardRef as ReactComponent };